import { FC } from 'react';

import dayjs from 'dayjs';
import { cn } from 'utils/helpers';

interface PROPS {
  className?: string;
}

const TermsPolicy: FC<PROPS> = ({ className }) => (
  <p className={cn('text-content text-sm absolute bottom-8', className)}>
    {dayjs().format('YYYY')} Terms of Service Privacy Policy
  </p>
);

export default TermsPolicy;
